const baseUrl = `https://homedecorpublic.s3.amazonaws.com/storefront/images`
export const storeFrontImages = [...Array(8).keys()].map(idx => ({
    before: `${baseUrl}/before/${idx + 1}.jpeg`,
    after: `${baseUrl}/after/${idx + 1}.jpeg`
}));
